import { EXPORT_TYPE_EXCEL, EXPORT_TYPE_PDF, EXPORT_TYPE_NAMES, MAIN_TAB } from '@constants'
import { titleCase } from '@components/shared/utils'
import cn from 'clsx'
import Checkbox from '$components/Forms/Checkbox'

const ExportRunsheetDialogReadyView = ({
    activeTab,
    templates,
    sheet,
    selectedTypes,
    selectedTemplate,
    tabToExport,
    onExportTypeChange,
    onTemplateChange,
    onTabToExportChange,
    onSheetChange,
}) => {
    
    return (
        
        <div className="flex mt-4 pb-4 gap-4">
            
            {activeTab === MAIN_TAB && <div className="flex flex-col my-1 pr-6 border-r border-neutral/20">
                <h5 className="mb-3"><b>Tabs to Export</b></h5>
                <div className="flex gap-2 items-center">
                    <input
                        id="main-tab"
                        type="radio"
                        checked={tabToExport === 'main'}
                        className="radio radio-sm"
                        onChange={() => onTabToExportChange('main')}>
                    </input>
                    <label htmlFor="main-tab" className="cursor-pointer px-1 py-2">
                        Main Tab Only
                    </label>
                </div>
                <div className="flex gap-2 items-center">
                    <input
                        id="all-tabs"
                        type="radio"
                        checked={tabToExport === 'all'}
                        className="radio radio-sm"
                        onChange={() => onTabToExportChange('all')}>
                    </input>
                    <label htmlFor="all-tabs" className="cursor-pointer px-1 py-2">
                        All Tabs
                    </label>
                </div>
            </div>}
            
            <div className="my-1">
                
                <h5 className="mb-3"><b>Export Types</b></h5>
                
                <Checkbox
                    labelClassName="gap-2"
                    label={EXPORT_TYPE_NAMES[EXPORT_TYPE_PDF]}
                    checked={selectedTypes.includes(EXPORT_TYPE_PDF)}
                    onChange={() => onExportTypeChange(EXPORT_TYPE_PDF)} />
                
                <Checkbox
                    labelClassName="gap-2"
                    label={EXPORT_TYPE_NAMES[EXPORT_TYPE_EXCEL]}
                    checked={selectedTypes.includes(EXPORT_TYPE_EXCEL)}
                    onChange={() => onExportTypeChange(EXPORT_TYPE_EXCEL)} />
            
            </div>
            
            {(selectedTypes.includes(EXPORT_TYPE_EXCEL)) && (
                
                <div className="border-l border-neutral/20 pl-4 flex-1">
                    
                    <h5 className="mb-4"><b>Excel Options</b></h5>
                    
                    <div className="flex gap-4">
                        <select
                            className={cn('flex-1 select select-bordered select-sm', {
                                'opacity-60': !templates[EXPORT_TYPE_EXCEL]?.length,
                            })}
                            value={selectedTemplate?.id ?? ''}
                            disabled={!templates[EXPORT_TYPE_EXCEL]?.length}
                            onChange={onTemplateChange}>
                            
                            {!templates[EXPORT_TYPE_EXCEL]?.length && (
                                <option value={null}>
                                    No templates available for {titleCase(EXPORT_TYPE_EXCEL, true)}
                                </option>
                            )}
                            
                            {templates[EXPORT_TYPE_EXCEL]?.map(it => (
                                <option key={`export-template-${it.id}`} value={it.id}>
                                    {it.name}
                                </option>
                            ))}
                        
                        </select>
                        
                        <select
                            className="flex-1 select select-bordered select-sm"
                            value={sheet ?? ''}
                            onChange={onSheetChange}>
                            {selectedTemplate?.sheets?.map(it => (
                                <option key={`export-sheet-${it}`} value={it}>
                                    {it}
                                </option>
                            ))}
                        </select>
                    </div>
                
                </div>
                
            )}
        
        </div>
        
    )
    
}

export default ExportRunsheetDialogReadyView
